module.exports = __webpack_public_path__ + "img/guide28804.696d151b.png";